import { BooleanParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
export class BooleanField extends MetadataField {
    constructor(rawValue) {
        super(BooleanParser.shared, rawValue);
    }
}
//# sourceMappingURL=boolean.js.map